function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import projectVersionService from '@rd-web-markets/shared/dist/services/claim_project_reports/project_versions.service';
import { Table } from '@rd-web-markets/shared/dist/util';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProjectVersionChanges from './ProjectVersionChanges';
import Pagination from '@rd-web-markets/shared/dist/util/Pagination';
import * as QueryString from 'query-string';
export default function ProjectUpdates(_ref) {
  let {
    report
  } = _ref;
  const [queryParams, setQueryParams] = useState(_objectSpread({
    page: 1
  }, QueryString.parse(location.search)));
  const {
    t
  } = useTranslation();
  const [projectVersions, setProjectVersions, fetchProjectVersions, totalPages] = projectVersionService.useFetchAll({
    projectId: report.id,
    initialQueryParams: queryParams
  });
  const [expandedVersions, setExpandedVersions] = useState(new Set());
  if (!(report !== null && report !== void 0 && report.id)) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const changePageTo = pageNumber => {
    window.scrollTo(0, 0);
    setQueryParams(_objectSpread(_objectSpread({}, queryParams), {}, {
      page: pageNumber
    }));
  };
  const toggleExpanded = versionId => {
    const newExpanded = new Set(expandedVersions);
    if (newExpanded.has(versionId)) {
      newExpanded.delete(versionId);
    } else {
      newExpanded.add(versionId);
    }
    setExpandedVersions(newExpanded);
  };
  const headers = [{
    text: t('update_type')
  }, {
    text: t('changed_by')
  }, {
    text: t('change_date_time')
  }, {
    text: t('entity_type_change')
  }, {
    text: t('change')
  }, {
    text: t('load_file')
  }];
  const rows = projectVersions.map(version => {
    return {
      key: version.id,
      columns: [version.version_change_type || version.event, version.user_name, createTimezonedDate(new Date(version.created_at), true).toCustomLocaleTimeString(), t(version.event_translation_key, {
        defaultValue: version.event_translation_key
      }), version.is_related_model ? version.summary_detail : /*#__PURE__*/React.createElement(ProjectVersionChanges, {
        version: version,
        isExpanded: expandedVersions.has(version.id),
        toggleExpanded: toggleExpanded
      }), version.attachment_url ? /*#__PURE__*/React.createElement("a", {
        href: version.attachment_url.url
      }, version.attachment_url.filename) : '']
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, Number(queryParams.page), " - ", totalPages), /*#__PURE__*/React.createElement(Table, {
    opts: {
      striped: true,
      className: 'ProjectUpdates-table'
    },
    headers: headers,
    rows: rows,
    showControls: false,
    rowTdStyle: {
      padding: '12px 8px',
      verticalAlign: 'top'
    }
  }), /*#__PURE__*/React.createElement(Pagination, {
    currentPage: Number(queryParams.page),
    totalPages: totalPages,
    handlePageChange: changePageTo
  }));
}